var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrthographic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 88 88",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cube"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43,42.6036l-38-20V66a1,1,0,0,0,.5342.8848L43,86.6036Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,40.87l38-20L44.4658,1.1152a1.001,1.001,0,0,0-.9316,0L6,20.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45,42.6036v44L82.4658,66.8848A1.0008,1.0008,0,0,0,83,66V22.6037Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrthographic);
export default __webpack_public_path__ + "static/media/orthographic.aec1b3a52eab88d25d2e2212f9ee67e3.svg";
export { ForwardRef as ReactComponent };